import { Badge } from '@admin-panel/ui';
import type { LookGroupListItem, ProductDepthSummary } from './types';
import { isPublishedQcStatus } from './helpers';

type GroupMetaProps = {
  item: LookGroupListItem;
  productDepth?: ProductDepthSummary;
};

const GroupMeta = ({ item, productDepth }: GroupMetaProps) => {
  const inventoryDepthLabel = productDepth?.isLoading
    ? '...'
    : productDepth?.isError
      ? 'NA'
      : String(productDepth?.inventoryDepth ?? 0);
  const jitDepthLabel = productDepth?.isLoading
    ? '...'
    : productDepth?.isError
      ? 'NA'
      : String(productDepth?.jitDepth ?? 0);

  return (
    <div className="space-y-2">
      <div className="flex items-start gap-5">
        <div className="min-w-0 border-l-2 border-foreground/80 pl-2">
          <p className="m-0 text-[10px] font-medium tracking-[0.12em] text-muted-foreground uppercase">
            Inventory Depth
          </p>
          <p className="m-0 text-base font-semibold leading-none text-foreground">
            {inventoryDepthLabel}
          </p>
        </div>
        <div className="min-w-0 border-l-2 border-border pl-2">
          <p className="m-0 text-[10px] font-medium tracking-[0.12em] text-muted-foreground uppercase">
            JIT Depth
          </p>
          <p className="m-0 text-base font-semibold leading-none text-foreground">
            {jitDepthLabel}
          </p>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-1.5 pt-0.5">
        {item.group.base_product_color ? (
          <Badge tone="neutral">Color: {item.group.base_product_color}</Badge>
        ) : null}
        {item.preview?.qcStatus ? (
          <Badge
            tone={
              isPublishedQcStatus(item.preview.qcStatus)
                ? 'success'
                : item.preview.qcStatus === 'rejected'
                  ? 'destructive'
                  : 'warning'
            }
          >
            {item.preview.qcStatus}
          </Badge>
        ) : null}
      </div>
    </div>
  );
};

export default GroupMeta;
